export default __webpack_public_path__ + "static/media/bannerimg.d17098e8.jpg";